import { API_URL_ADMIN } from "../../../constants/env";
import { apiPrivateAxiosWithBaseURL } from "../../axios";
import { IAdminFacilityData } from "./types";

export const adminFacilityRequest = {
  getFacilityAdminDetails: (): Promise<IAdminFacilityData> => {
    const facilityKey = localStorage.getItem('facilityKey');
    return apiPrivateAxiosWithBaseURL.get(`/facility/${facilityKey}`, {
      baseURL: API_URL_ADMIN
    })
  }
};
